export default "__VITE_ASSET__NDCeurZA__"